import { render, staticRenderFns } from "./CollectionGrid.vue?vue&type=template&id=4c95e11a&scoped=true"
import script from "./CollectionGrid.vue?vue&type=script&lang=js"
export * from "./CollectionGrid.vue?vue&type=script&lang=js"
import style0 from "./CollectionGrid.vue?vue&type=style&index=0&id=4c95e11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c95e11a",
  null
  
)

export default component.exports